import axiosInstance from "../../../Utils/axiosInstance";

export const fetchCurrentUser = async () => {
  try {
    const response = await axiosInstance.get("/company/current/user/");
    const data = response.data.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchClearerName = async () => {
  try {
    const response = await axiosInstance.get(
      "/paper-app/paper-trading-clearer"
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchClearer = async () => {
  try {
    const response = await axiosInstance.get(
      "/paper-app/clearers/"
    );
    return { data: response.data.results, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchCommodityOptionsList = async () => {
  try {
    const response = await axiosInstance.get(
      "/paper-app/commodities/"
    );
    return { data: response.data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchComodityOptions = async (id: string) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-comodity-option/${id}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};
export const fetchContractOptions = async () => {
  try {
    const response = await axiosInstance.get(
      '/paper-app/contract-contracts/'
    );

    return { data: response.data, error: null };
  } catch (error: any) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
    };
  }
};

export const fetchclearingAccountOptions = async () => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-clearing-account/`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchUnitOptions = async (id: string) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-unit/${id}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchTickOptions = async (id: string) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-tick/${id}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchHolidayOptions = async (id: string) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-holiday/${id}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchBrokerNameOptions = async (id: string) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-broker-option/${id}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchBrokerOptions = async () => {
  try {
    const response = await axiosInstance.get('/paper-app/broker-list/');
    return { data: response.data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || 'Unknown error';
    return { data: null, error: message };
  }
};

export const fetchPhysicalCodeOptions = async () => {
  try {
    const response = await axiosInstance.get('/paper-app/physical-codes/');
    return { data: response.data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || 'Unknown error';
    return { data: null, error: message };
  }
};



export const fetchBookOptions = async () => {
  try {
    const response = await axiosInstance.get(`paper-app/paper-trading-book/`);
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const strategyOptions = async () => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-strategy/`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const FutureSwapsOptions = async (id: string) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-futre-swaps/${id}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const BookOptions = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/paper-app/paper-trading-book/`);
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const StrategyOptions = async (id: string) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-futre-swaps/${id}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const paperTradingCustomerOptions = async () => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-customer-companies-unique/`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchCustomerAccountOptions = async (customerName: string) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-customer-account-number/?customer=${customerName}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const paperTradingGetAccountNo = async (id: string) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-trading-get-account-number/${id}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const callPaperTradingTypeOptions = async () => {
  try {
    const response = await axiosInstance.get(`/paper-app/paper-trading-type/`);
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const fetchloadAutoID = async (
  trade_type: string,
  type: string,
  comodity: string
) => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/paper-auto-id?trade_type=${trade_type}&type_=${type}&commodity_id=${comodity}`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const bulkDelete = async (execIds: string[]) => {
  try {
    const response = await axiosInstance.delete(
      "/paper-app/paper-trading/bulk-delete/",
      { data: { exec_ids: execIds } } // DELETE requests send payload in `data`
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
      "Failed to delete records. Please try again."
    );
  }
};

export const fetchTasMmOptions = async () => {
  try {
    const response = await axiosInstance.get("/paper-app/TAS-MM-dropdown/");
    return { data: response.data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};